import React, { useEffect } from 'react';
import VoucherGroupTable from 'components/management/tables/VoucherCategoryTable';
import { useStoreWrapper } from 'stores/StoreHelper';
import { AdminVoucherCategoryDto } from 'services/data-contracts';
import VoucherCategoryView from 'components/management/modals/VoucherCategoryView';
import VoucherCategoryEdit from 'components/management/modals/VoucherCategoryEdit';
import { useLocation } from 'react-router-dom';
import { getUrlParam } from 'libs/helper/utils';
import VoucherCategoryFilter from 'components/management/filters/VoucherCategoryFilter';
import { observer } from 'mobx-react-lite';
import NoContents from 'components/commons/\bNoContents';
const VoucherCategoryPage = observer(() => {
  const { uiStore } = useStoreWrapper();
  const { voucherFilterStore } = useStoreWrapper();
  const location = useLocation();

  // const voucherGroups = ServiceHelper.getVoucherGroups();
  useEffect(() => {
    const search = getUrlParam('search');
    const page = getUrlParam('page');
    const size = getUrlParam('size');

    voucherFilterStore.getVoucherCategories({
      keyword: search || '',
      page: page ? parseInt(page) : undefined,
      size: size ? parseInt(size) : 20,
    });
  }, [location.search]);

  const handleRowClick = (voucherCategory: AdminVoucherCategoryDto) => {
    uiStore?.modal.show({
      title: '바우처 그룹 상세',
      style: {
        maxWidth: '800px',
        height: 'auto',
        maxHeight: '80vh',
      },
      children: <VoucherCategoryView voucherCategory={voucherCategory} />,
    });
  };

  const handleEditClick = (voucherCategory?: AdminVoucherCategoryDto) => {
    const size = getUrlParam('size');
    uiStore?.modal.show({
      title: '바우처 그룹 수정',
      style: {
        maxWidth: '800px',
        height: '100%',
        maxHeight: '80vh',
      },
      children: <VoucherCategoryEdit voucherCategory={voucherCategory} />,
      onConfirmed: () => {
        voucherFilterStore.getVoucherCategories({
          page: 0,
          size: size ? parseInt(size) : 20,
        });
      },
    });
  };

  return (
    <div>
      <VoucherCategoryFilter
        onClickAdd={() => {
          handleEditClick();
        }}
      />
      <VoucherGroupTable
        voucherCategories={voucherFilterStore?.voucherCategories}
        onRowClick={(row: AdminVoucherCategoryDto) => {
          handleRowClick(row);
        }}
        onEditClick={(row: AdminVoucherCategoryDto) => {
          handleEditClick(row);
        }}
      />
      <NoContents>표시할 데이터가 없습니다.</NoContents>
    </div>
  );
});

export default VoucherCategoryPage;
